import { render, staticRenderFns } from "./EmailNotificationTemplateModal.vue?vue&type=template&id=374bbd29&scoped=true"
import script from "./EmailNotificationTemplateModal.vue?vue&type=script&lang=js"
export * from "./EmailNotificationTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./EmailNotificationTemplateModal.vue?vue&type=style&index=0&id=374bbd29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374bbd29",
  null
  
)

export default component.exports